export const formatCalendarDate = (date) =>
  new Date(date).toLocaleDateString("en-CA");

/** Диапазон для режима периода (АДМС): от начала до конца выбранного периода */
export const getCalendarRangeForPeriod = (startDate, endDate) => {
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);

  const firstDay = start <= end ? start : end;
  const lastDay = start <= end ? end : start;

  return {
    dateFrom: formatCalendarDate(firstDay),
    dateTo: formatCalendarDate(lastDay),
  };
};

/** Диапазон для обычных пользователей: 4 дня включая сегодня (ограничение выбора даты) */
export const getFourDayCalendarRange = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const firstDay = new Date(today);
  firstDay.setDate(today.getDate() - 3);

  return {
    dateFrom: formatCalendarDate(firstDay),
    dateTo: formatCalendarDate(today),
  };
};

/**
 * Диапазон для подсветки выходных/праздников в DatePicker.
 * Предыдущий, текущий и следующий месяц относительно referenceDate.
 */
export const getDatepickerCalendarRange = (referenceDate = new Date()) => {
  const ref = new Date(referenceDate);
  const firstDay = new Date(ref.getFullYear(), ref.getMonth() - 1, 1);
  const lastDay = new Date(ref.getFullYear(), ref.getMonth() + 2, 0);

  return {
    dateFrom: formatCalendarDate(firstDay),
    dateTo: formatCalendarDate(lastDay),
  };
};

/**
 * Диапазон календаря в режиме периода: с padding по месяцам вокруг выбранных дат,
 * чтобы в DatePicker подсвечивались выходные при выборе начала/конца по отдельности.
 */
export const getCalendarRangeForPeriodMode = (
  periodStartDate,
  periodEndDate,
) => {
  const anchor = periodStartDate || periodEndDate || new Date();

  if (periodStartDate && periodEndDate) {
    const start = new Date(periodStartDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(periodEndDate);
    end.setHours(0, 0, 0, 0);
    const rangeStart = start <= end ? start : end;
    const rangeEnd = start <= end ? end : start;

    const firstDay = new Date(
      rangeStart.getFullYear(),
      rangeStart.getMonth() - 1,
      1,
    );
    const lastDay = new Date(rangeEnd.getFullYear(), rangeEnd.getMonth() + 2, 0);

    return {
      dateFrom: formatCalendarDate(firstDay),
      dateTo: formatCalendarDate(lastDay),
    };
  }

  return getDatepickerCalendarRange(anchor);
};
